import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { StationNameComponent } from '@components/station-name/station-name.component';
import { Station } from '@models/responses/station-response.model';
import { AppCopy } from '@models/cms/app.model';
import { TripType } from '@constants/home.constants';
import { SearchRequest } from '@models/requests/search-request.model';

@Component({
  selector: 'app-modify-search-criteria',
  standalone: true,
  templateUrl: './modify-search-criteria.component.html',
  styleUrls: ['./modify-search-criteria.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, StationNameComponent],
})
export class ModifySearchCriteriaComponent {
  @Input() dates: string;
  @Input() cmsAppCopy: AppCopy;
  @Input() stations: Station[] | null;
  @Input() searchInput: SearchRequest | null;
  @Input() travelers: string;
  @Input() tripType: TripType | null;
  @Input() disabled: boolean;

  @Output() modifyClick = new EventEmitter();

  readonly TripType = TripType;

  stationName(code: string | undefined): string {
    return (
      this.stations?.find((station) => station.stationCode === code)
        ?.fullName || ''
    );
  }

  modify() {
    if (!this.disabled) {
      this.modifyClick.emit()
    }
  }
}
